export default __webpack_public_path__ + "static/media/Contrast.356edf27.svg";